import { UserSettingsKeys } from "constants/user-settings-keys";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import useFeatureFlags from "utilities/hooks/use-feature-flags";

/**
 * Custom hook that determines if Notebooks are enabled based on feature flags and user settings
 * @returns boolean indicating if Notebooks should be available to the user
 */
const useNotebooksEnabled = (): boolean => {
    const { useNotebooks } = useFeatureFlags();
    const { globalState } = useGlobalState();

    const enableNotebookSetting: boolean =
        globalState.getUserSettingValue(UserSettingsKeys.EnableNotebook) ??
        false;

    return useNotebooks && enableNotebookSetting;
};

export default useNotebooksEnabled;
